import { ENABLE_TENANT_LOGGING, LOG_LEVEL, MODE, PROD, SENTRY_LOG_LEVEL } from '@/env';
import { addBreadcrumb, captureException, type SeverityLevel } from '@sentry/react';
import { logger, mapConsoleTransport, type transportFunctionType } from 'react-native-logs';

const levels = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3,
} as const;

const customSentryTransport: transportFunctionType<object> = (props) => {
  if (
    !props.rawMsg ||
    !Array.isArray(props.rawMsg) ||
    props.level.severity < levels[SENTRY_LOG_LEVEL]
  ) {
    return;
  }

  const formattedLevel = props.level.text === 'warn' ? 'warning' : props.level.text;

  if (
    props.level.severity === levels.debug ||
    props.level.severity === levels.info ||
    props.level.severity === levels.warn
  ) {
    addBreadcrumb({
      level: formattedLevel as SeverityLevel,
      message: props.msg,
    });
    return;
  }

  const { rawMsg, msg } = props;
  const error = rawMsg.find((arg: unknown) => arg instanceof Error);
  if (error) {
    addBreadcrumb({
      level: formattedLevel as SeverityLevel,
      message: msg,
    });
    captureException(error);
  } else {
    captureException(new Error(msg));
  }
};

let transport = null;
if (PROD) {
  if (ENABLE_TENANT_LOGGING) transport = [mapConsoleTransport, customSentryTransport];
  else transport = customSentryTransport;
} else {
  transport = mapConsoleTransport;
}

const log = logger.createLogger({
  levels,
  severity: LOG_LEVEL,
  transport,
  transportOptions: {
    mapLevels: {
      debug: 'log',
      info: 'info',
      warn: 'warn',
      error: 'error',
    },
  },
  async: true,
  dateFormat: 'time',
  printLevel: true,
  printDate: true,
  fixedExtLvlLength: false,
  enabled: MODE !== 'test',
});

export default log;
